module.exports = {"652901001":"兰干街道","652901002":"英巴扎街道","652901003":"红桥街道","652901004":"新城街道","652901005":"南城街道","652901006":"柯柯牙街道","652901007":"多浪街道","652901100":"喀拉塔勒镇","652901101":"阿依库勒镇","652901200":"依干其乡","652901201":"拜什吐格曼乡","652901202":"托普鲁克乡","652901203":"库木巴什乡","652901404":"实验林场","652901407":"纺织工业城","652901408":"经济技术开发区","652901409":"特色产业园区","652901410":"柳源农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652901.json
// module id = 3233
// module chunks = 0